import NavBar from "../../components/organisms/navbar";
import {
  Container,
  Content,
  PageLocationTitle,
  PageTitle,
  PageTitleContainer,
  TournamentContainer,
  TournamentList,
  TournamentItem,
  TournamentImageContent,
  TournamentImage,
  TournamentContent,
  TournamentTitle,
  TournamentDescription,
  TournamentActions,
  TournamentLink,
  BR,
} from "./styles";

const DividaJander = () => {
  return (
    <>
      <div translate="no">
        <NavBar />
        <Container>
          <Content>
            <PageTitleContainer>
              <PageLocationTitle>DÍVIDAS.</PageLocationTitle>
              <PageTitle>Ficha financeira do Jander</PageTitle>
            </PageTitleContainer>
            <TournamentContainer>
              <TournamentList>
                <TournamentItem>
                  <TournamentImageContent>
                    <TournamentImage
                      src={require("../../assets/images/tournaments/divida-jander/dividaJander.jpg")}
                    />
                  </TournamentImageContent>
                  <TournamentContent>
                    <TournamentTitle>
                      {"Dívidas com o Jander".toUpperCase()}
                    </TournamentTitle>
                    <TournamentDescription>
                      <BR />
                      <span><b>Status:</b> Em aberto</span><br />
                      <span>• Contrato 1</span><br />
                      <span>• Contrato 2</span>
                      <BR />
                      <span style={{ color: "red" }}>
                        <b>Data de pagamento: Dia 01 de cada mês</b>
                      </span>
                      <BR />
                      <strong style={{ color: "red" }}>
                        Ultimo pagamento: 01/MAIO/2026	
                      </strong>
                    </TournamentDescription>
                  </TournamentContent>
                  <TournamentActions>
                    <TournamentLink as="a" href="https://docs.google.com/spreadsheets/d/e/2PACX-1vSa5A2PDIjVO0H0tYTxiqUthHB0XqvB1_7ldV9ZZkenHXb__xghUNYM88e5W_LYDHZrOLNZU3opM4Py/pubhtml" target="_blank" rel="noopener noreferrer">
                        Abrir planilha
                    </TournamentLink>
                  </TournamentActions>
                </TournamentItem>
              </TournamentList>
            </TournamentContainer>
          </Content>
        </Container>
      </div>
    </>
  );
};

export default DividaJander;
